export default {
  title: 'Nebula buds AI通話', // "Nebula buds AI通话" 翻译为日文
  userID: 'ユーザーID : ', // "用户ID : "
  hurryUp: '相手からの呼び出しを待機中', // "等待对方呼叫"
  waitingCall: 'このページで相手からの呼び出しを待っています。ページを早く閉じないでください。', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: '字幕切替', // "字幕开关"
  initWait: '初期設定を待機中', // "等待初始化"
  initSuccess: '初期設定完了、相手からの呼び出しを待機中。ページを閉じないでください！', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: '通話接続済み', // "电话接通"
  callEnd: '通話終了', // "通话结束"
  careful: '注意 : ', // "注意 : "
  wait: '通話コンポーネントが準備完了、相手からの呼び出しを待機中', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'アラビア語', // "阿拉伯语"
    da: 'デンマーク語', // "丹麦语"
    de: 'ドイツ語', // "德语"
    en: '英語', // "英语"
    es: 'スペイン語', // "西班牙语"
    fil: 'フィリピン語', // "菲律宾语"
    fr: 'フランス語', // "法语"
    hi: 'ヒンディー語', // "印地语"
    id: 'インドネシア語', // "印度尼西亚语"
    it: 'イタリア語', // "意大利语"
    ja: '日本語', // "日文"
    ko: '韓国語', // "韩语"
    ms: 'マレー語', // "马来语"
    no: 'ノルウェー語', // "挪威语"
    pt: 'ポルトガル語', // "葡萄牙语"
    ru: 'ロシア語', // "俄语"
    sv: 'スウェーデン語', // "瑞典语"
    th: 'タイ語', // "泰语"
    tr: 'トルコ語', // "土耳其语"
    vi: 'ベトナム語', // "越南语"
    zh: '中国語' // "中文"
  }
}
